import React from 'react'
import { Subscribe } from '../components/forms/Subscribe'
import { Link } from 'react-router-dom'
import { FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
import { BiLogoGmail } from 'react-icons/bi'


export const Footer = ({ header }) => {
    return (
        // This is the footer
        <div className='w-full flex flex-col justify-center items-center min-h-[100vh] bg-[#262426] text-white py-10 px-[5vw]'>
            {/* // This is the footer Title */}
            <h2 className='text-4xl font-semibold text-center'>
                {header.map((item) => (
                    <>
                        {item}
                        <br />
                    </>
                ))}
            </h2>

            {/* // This is the Subscribe division */}
            <div className='mt-16'>
                <Subscribe />
            </div>

            {/* // This is the footer logo */}
            <div className='p-6 bg-blue-500 rounded-full mt-20'>

            </div>

            {/* // This is the Brand Name */}
            <h2 className='text-4xl font-semibold text-center mt-5'>
                N6T Technologies
            </h2>

            {/* // This is the navigation */}
            <ul className=' mt-14 text-xl w-full flex space-x-5 flex-wrap justify-around'>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/product">Products</Link></li>
                <li><Link to="/privacy_policy">Privacy Policy</Link></li>
                <li><Link to="/clinq_us">Clinq Us</Link></li>
                <li><Link to="/resources">Resources</Link></li>
            </ul>

            {/* // These are the Social Links*/}
            <ul className=' mt-16 text-xl flex flex-wrap space-x-5 justify-center items-center'>
                <li className='w-10 h-10 flex justify-center items-center bg-blue-700 rounded-full'>
                    <Link to="">
                        <FaLinkedin />
                    </Link>
                </li>
                <li className='w-10 h-10 flex justify-center items-center bg-blue-700 rounded-full'>
                    <Link to="">
                        <FaTwitter />
                    </Link>
                </li>
                <li className='w-10 h-10 flex justify-center items-center bg-blue-700 rounded-full'>
                    <Link to="">
                        <FaInstagram />
                    </Link>
                </li>
                <li className='w-10 h-10 flex justify-center items-center bg-blue-700 rounded-full'>
                    <Link to="">
                        <BiLogoGmail />
                    </Link>
                </li>
            </ul>
        </div>
    )
}
